import { Button, Card, Text } from "../../../components";
import Localization from "../../../localization";
import styled from "styled-components";
import { Flex } from "antd";
import React from "react";

const Item = ({
  promoted,
  title = "",
  price = 0,
  details = [],
  period = "",
  onSelect = () => {},
}) => {
  const isMonthly = period === "monthly";

  return (
    <Styled
      className="h-100"
      promoted={promoted}
      title={{ type: "secondary", children: title }}
      classNames={{ header: "p-0 m-10-b", body: "h-100 d-flex flex-column" }}
    >
      <Flex vertical flex={1} gap={"7.3rem"} justify="space-between">
        <div>
          <Text
            size={42}
            weight={700}
            className="m-25-b price"
            lineHeight="4.2rem"
            children={`${price} kr/${(isMonthly
              ? Localization.general.month
              : Localization.general.year
            ).toLowerCase()}`}
          />
          {React.Children.toArray(
            details.map((_, index) => (
              <div>
                {!!index && (
                  <div
                    className="m-12-v"
                    style={{
                      background: "black",
                      width: "100%",
                      height: ".1rem",
                    }}
                  />
                )}
                <Text
                  level={5}
                  weight={700}
                  type="secondary"
                  children={_.title}
                />
                <Text
                  weight={400}
                  type="secondary"
                  className="m-5-t"
                  children={_.description}
                />
              </div>
            ))
          )}
        </div>
        <div>
          <Button
            type="primary"
            onClick={onSelect}
            title={Localization.general.select}
          />
        </div>
      </Flex>
    </Styled>
  );
};

const Styled = styled(Card)`
  min-height: 50rem;
  background: ${(_) =>
    !_.promoted
      ? _.theme.token.surface.primary
      : _.theme.token.alerts.error.background};
  ${(_) => _.theme.mobile("min-height: unset !important;")}
  .price {
    ${(_) => _.theme.mobile(`font-size: 3.2rem !important;`)}
  }
  .ant-card-body {
    ${(_) => _.theme.mobile(`padding: 2rem;`)}
  }
`;

export default Item;
